import { ref } from 'vue'

export default () => {
  const resolveNavItemComponent = item => {
    if (item.subheader) return 'vertical-nav-menu-section-title'
    if (item.children && !item.to) return 'vertical-nav-menu-group'
    if (item.children && item.to) return 'vertical-nav-menu-group-link'

    return 'vertical-nav-menu-link'
  }

  const isMouseHovered = ref(false)

  return {
    isMouseHovered,
    resolveNavItemComponent,
  }
}
